<ng-container *ngFor="let sport of preMatchobservable | async | groupBySportId">
  <!--  <div class="tipp-bar">-->
  <!--    <span>{{sport.SportName}}</span>-->
  <!--  </div>-->
  <ng-container *ngFor="let fixture of sport.eEvents | groupByTournamentId | sortBy : false : 'SequenceNumber'" class="tab-content event-cont">
    <matches
      (addOdd)="addOddListener($event)"
      [__fixture]="fixture"
      [_selectedOdds]="_selectedOdds"
      [oddType]="oddMarketingValue"
      [_sportName]="sport.SportNameOriginal"
      [oddTiles]="oddTiles"></matches>
  </ng-container>
</ng-container>

<!--<virtual-scroller #scroll
                  [items]="preMatchobservable | async"
                  [enableUnequalChildrenSizes]="true"
                  [bufferAmount]="10"
                  [scrollAnimationTime]="0"
                  [scrollDebounceTime]="10"
                  [stripedTable]="true"
                  [useMarginInsteadOfTranslate]="true"
                  [compareItems]="compareItems"
                  [ngStyle]="{height: '867px'}">

  <ng-container *ngFor="let sport of scroll.viewPortItems  | groupBySportId;">-->
<!--  <div class="tipp-bar">-->
<!--    <span>{{sport.SportName}}</span>-->
<!--  </div>-->
<!--<ng-container *ngFor="let fixture of sport.eEvents | groupByTournamentId | sortBy: false: 'SequenceNumber'"
                  class="tab-content event-cont">
      <matches (addOdd)="addOddListener($event)"
               [__fixture]="fixture"
               [_selectedOdds]="_selectedOdds"
               [oddType]="oddMarketingValue"
               [_sportName]="sport.SportNameOriginal"></matches>
    </ng-container>
  </ng-container>

</virtual-scroller>-->
